<template>
  <div>

    <div style="margin-top:5px;">
      <div style="text-align:left;">
        <h6 style="padding:5px; display:inline-block; text-align:left; background-color:darkblue; color: white;">尚未信託金額</h6>
      </div>
      <template v-if="remain_balance">
        
        <table class="remain_table">
          <thead>
            <th class="type">類別</th>
            <th class="cnt">張數</th>
            <th class="sum">金額</th>
          </thead>

          <tbody>
            <tr v-for="(detail, idx) in remain_balance.detail" :key="idx">
              <td class="type">{{parseType(detail.type)}}</td>
              <td class="cnt">{{detail.cnt}}</td>
              <td class="sum">{{parseThousand(detail.sum)}}</td>
            </tr>
            <tr>
              <td style="font-weight:bold; text-align:right;">總計</td>
              <td class="cnt" style="font-weight:bold;">{{cnt_count}}</td>
              <td class="sum" style="font-weight:bold;">{{parseThousand(sum_count)}}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>

    <populate-form
      collapseStyle="simple"
      :formTitle="'放款作業查詢'" 
      fkey="sm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="optionValueChanged"
    >
      <h3>WOW</h3>
    </populate-form>
    <div class="wrapper2" ref="wrapper" @scroll="handleScroll">
      <b-table ref="scrollarea" striped stacked="sm" hover :items="PaymentOperationList" :fields="fields" @scrolldownend="searchOperations(true)">
        <template v-slot:cell(created_date)="row">
          <!--把created_at的字串取出日期部分顯示-->
          {{row.item.created_at.substring(0,10)}}
        </template>
        <template v-slot:cell(operation_status)="row">
          <!--綜合判斷顯示狀態字串,已取消最優先,再判斷已確認放款,最後判斷已下載,都否則未下載-->
          {{row.item.aborted==1?'已取消':(row.item.payment_confirmed==1?'已確認放款':(row.item.downloaded==1?'已下載':'未下載'))}}
        </template>
        <template v-slot:cell(actions)="row">
          <b-button class="mr-1" size="sm" @click="downloadFile(row.item)">下載電文</b-button>
          <b-button class="mr-1" size="sm" @click="downloadXls(row.item)">下載Xls</b-button>
          <b-button class="mr-1" size="sm" @click="showOperationDetail(row.item)">顯示關聯請款單</b-button>
          <b-button class="mr-1" v-if="row.item.payment_confirmed===0&&row.item.aborted===0&&lockIconIndex&&filterOptions[lockIconIndex].btnIcon==='unlock'" size="sm" @click.stop="confirmCancel(row.item)">
            手動取消
          </b-button>
          <!-- <b-button class="mr-1" size="sm" @click.stop="chose_target_payment_date(row.item)">
            確認放款
          </b-button> -->
          <b-button class="mr-1" v-if="row.item.payment_confirmed===0&&row.item.aborted===0&&row.item.downloaded===1" size="sm" @click.stop="chose_target_payment_date(row.item)">
            確認放款
          </b-button>
        </template>
      </b-table>
    </div>
    <b-modal
      id="createFrm"
      ref="createFrm"
      size="xl"
      v-model="modalManualCreateShow"
      centered
      title="手動建立放款作業"
      hide-footer
    >
      <!--上面提供全選/全取消按鈕與當前選取總計金額顯示-->
      <div style="display: flex;flex-flow: row wrap;align-items:center;">
        <b-button class="mr-1" @click="selectAll">全選</b-button>
        <b-button @click="unSelectAll">全不選</b-button>
        <b-form-input class="ml-1 col-md-2" type="text" @keyup.enter="popupFilterList" placeholder="單號/發票號篩選" v-model="popup_filter_no" />
        <b-form-input class="mx-1 col-md-2" type="text" @keyup.enter="popupFilterList" placeholder="供應商名篩選" v-model="popup_filter_name" />
        <span class="ml-2">當前勾選總金額：{{create_total}}</span>
      </div>
      <div style="display: flex;flex-flow: row wrap;align-items:center; margin-top:20px;">
        <b-form-input class="ml-1 col-md-5" type="date" v-model="popup_filter_start_at" />
        <b-form-input class="ml-1 col-md-5" type="date" v-model="popup_filter_end_at" />
        <b-button @click="popupFilterList">篩選</b-button>
      </div>
      <br>
      <!--一個b-table列表可以勾選的請款單,可以全選,再兩顆按鈕確認和取消-->
      <div class="form_selection_table">
        <b-table :items="formListFiltered" :fields="formFields">
          <template v-slot:cell(selected)="row">
            <b-form-checkbox class="mx-auto" v-model="row.item.selected" @change="calCreateTotal" />
          </template>
        </b-table>
      </div>
      <div>
        <b-button class="mx-3" @click="modalManualCreateShow=false">取消</b-button>
        <b-button class="mx-3" @click="manaulCreateOperationConfirm">確認</b-button>
      </div>
    </b-modal>
    <b-modal
      id="detailFrm"
      ref="detailFrm"
      size="lg"
      v-model="modalShowDetail"
      centered
      title="顯示對應請款單明細"
      hide-footer
    >
      <b-button class="mx-4" @click="download_detail_xls">下載此請款作業全部明細票券excel</b-button>
      <div class="detail_supplier" v-for="supplier in operation_detail" :key="supplier.merchant_id">
        <div>
          <span>{{supplier.supplier_id}}-{{supplier.merchant_name}}({{supplier.winton_id}})</span>
          <!--<span>{{supplier.remit_bank_no}}{{supplier.remit_bank_cname}}-{{supplier.remit_bankbranch_no}}{{supplier.remit_bankbranch_cname}}:{{supplier.remit_id}}-{{supplier.remit_title}}</span>-->
          <span style="float:right;">供應商總付款金額：{{supplier.remit_pay_price}}</span>
        </div>
        <ul>
          <li v-for="form in supplier.merchant_request_forms" :key="form.id">
            {{form.pf}}({{form.form_status}})&nbsp;原始請款金額：{{form.request_amount}}&nbsp;確認匯款金額：{{form.remit_amount_final}}
          </li>
        </ul>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      v-model="modalShowDatePicker"
      centered
      title="指定供應商看到的放款日期"
      hide-footer
    >
      <div class="mb-3">
          <date-picker v-model="target_payment_date"></date-picker>
      </div>

      <div>
        <b-button class="mx-3" @click="modalShowDatePicker=false">取消</b-button>
        <b-button class="mx-3" @click="confirm_target_payment_date">確認</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  apiGetTicketRemainBalance
} from '@/api/AdminManage.js'

import {
  apiGetPaymentOperationList,
  apiSetPaymentOperationDownloaded,
  apiSetPaymentOperationConfirmed,
  apiGetPaymentOperationDetailSummary,
  apiCancelPaymentOperation,
  apiCreatePaymentOperationManual,
  apiDownloadPaymentOperationDetailXls 
} from '@/api/PaymentOperation.js'

import {
  apiGetPaymentRequestFormList
} from '@/api/Merchant.js'

import { 
  apiDownloadFile
} from '@/api/Util.js'

import saveAs from 'file-saver'
import IndexPage from '../IndexPage.vue'

export default {
  name: 'PaymentOperation',
  components: {
    IndexPage

  },
  data: function () {
    return {
      tmp_operation_item: null,
      modalShowDatePicker: false,
      target_payment_date: new Date(),
      modalShowDetail:false,
      lockIconIndex:-1,
      //cnacelIndex: -1,
      filterData: {},
      filterOptions:[
        {
          'componentType':'text',
          'akey':'form_id',//其實應該是operation_id,但controller開錯參數名懶得改了
          'defaultValue':'',
          'col':3,
          'placeholder':"RSP編號查詢",
          'title':"若輸入則篩選指定放款作業編號",
          execCallback:this.searchOperations
        },
        {
          'componentType':'b-form-select',
          'akey':'downloaded',
          'dataOptions':[{text:'全部',value:''},{text:'已下載',value:'1'},{text:'未下載',value:'0'}],
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選電文下載狀態",
        },
        {
          'componentType':'b-form-select',
          'akey':'confirmed',
          'dataOptions':[{text:'全部',value:''},{text:'已確認放款',value:'1'},{text:'未確認放款',value:'0'}],
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選放款完成更新狀態",
        },
        {
          'componentType':'b-form-select',
          'akey':'aborted',
          'dataOptions':[{text:'全部',value:''},{text:'已取消',value:'1'},{text:'有效',value:'0'}],
          'defaultValue':'0',
          'col':3,
          'placeholder':"篩選取消狀態",
        },
        {
          'componentType':'date-picker',
          'akey':'created_from',
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選建立日期起",
          'title':"篩選建立日期起",
        },
        {
          'componentType':'date-picker',
          'akey':'created_to',
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選建立日期迄",
          'title':"篩選建立日期迄",
        },
        {
          'componentType':'date-picker',
          'akey':'confirmed_from',
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選完成日期起",
          'title':"篩選確認匯款完成日期起",
        },
        {
          'componentType':'date-picker',
          'akey':'confirmed_to',
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選完成日期迄",
          'title':"篩選確認匯款完成日期迄",
        },
        {
          componentType:'b-button',
          col:1,
          akey:'showForceCancel',
          btnIcon:'lock',
          title:'點擊解鎖後才可以手動取消放款作業',
          execCallback:this.switchLock
        },
        {
          componentType:'b-button',
          col:2,
          placeholder:'查詢',
          execCallback:this.searchOperations
        },
        {
          components:'span',
          col:6,
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:'手動建立放款作業',
          execCallback:this.showManualCreate
        }
      ],
      showFilter: true,
      datePicketOptions: {
        format: 'YYYY/MM/DD',
        useCurrent: false,
      },
      fields: [
        {
          key: 'remit_file_id',
          label: '放款作業單號',
          sortable: false
        },
        {
          key: 'created_date',
          label: '建立日期',
          sortable: false
        },
        {
          key: 'operation_status',
          label: '狀態',
          sortable: false
        },
        {
          key: 'payment_rows',
          label: '放款供應商數',
          sortable: false
        },
        {
          key: 'payment_forms',
          label: '關聯請款單數',
          tdClass: 'text-right',
          sortable: false
        },
        {
          key: 'total_payment',
          label: '總金額',
          tdClass: 'text-right',
          sortable: false
        },
        {
          key: 'actions',
          label: '操作',
          sortable: false
        },
      ],
      dismissSecs: 1,
      dismissCountDown: 0,
      //modalShow: false,
      //Merchants: [],
      //SelectedMerchantId: null,
      //SelectedMerchantItem: Object,
      //SelectedMerchant: Object,
      //CachedMerchant: Object, //用merchant_id當key的merchant_info cache
      //CachedLoginStores: Object, //用merchant_store_id當key的merchant_store login cache
      //Stores: [],
      //SelectedStoreId: null,
      //SelectedStoreAccount: '',
      //Services: [],
      //SelectedServiceId: null,
      isLoading:false,
      pageNumber:0,
      itemsPerPage:20,
      hasMore:true,
      QueryExecutionListResult: [],
      PaymentOperationList:[],
      //可供被挑選手動建立放款作業的請款單(狀態必須是downloaded,此狀態的定義可能會調整成管理部已確認)
      formList:[],
      formListFiltered:[],
      formFields:[
        {key:'selected',label:'選取' ,sortable: false},
        {key:'format_download_confirm_time',label:'下載時間', sortable: true},
        {key:'pf',label:'單號',sortable: false},
        {key:'invoice_no',label:'發票',sortable: false},
        {key:'merchant_name',label:'供應商',sortable: false},
        {key:'tickets_inside',label:'內含票券數',tdClass: 'text-right', sortable: false},
        {key:'remit_amount_final',label:'待匯款金額',tdClass: 'text-right', sortable: false},
      ],
      popup_filter_no:'',
      popup_filter_name:'',
      popup_filter_start_at: null,
      popup_filter_end_at: null,
      modalManualCreateShow:false,
      create_total:0,
      //default沒抓到資料的值
      operation_detail_default:[
        {
          "merchant_id": 0,
          "winton_id": "",
          "supplier_id": "無資料",
          "merchant_name": "無資料",
          "identity_id": "無資料",
          "remit_bank_no": "",
          "remit_bank_cname": "",
          "remit_bankbranch_no": "無資料",
          "remit_bankbranch_cname": "無資料",
          "remit_id": "",
          "remit_title": "",
          "remit_email": "",
          "remit_pay_price":0,
          "merchant_request_forms": [
            {
              "id": 0,
              "pf": "無資料",
              "form_status": "無資料",
              "request_amount": "0",
              "remit_amount_final": "0"
            }
          ]
        }
      ],
      //為了在popup裡面提供下載需要記得id＝＝
      focus_operation_id:0,
      operation_detail:[
        {
          "merchant_id": 0,
          "winton_id": "",
          "supplier_id": "無資料",
          "merchant_name": "無資料",
          "identity_id": "無資料",
          "remit_bank_no": "",
          "remit_bank_cname": "",
          "remit_bankbranch_no": "無資料",
          "remit_bankbranch_cname": "無資料",
          "remit_id": "",
          "remit_title": "",
          "remit_email": "",
          "remit_pay_price":0,
          "merchant_request_forms": [
            {
              "id": 0,
              "pf": "無資料",
              "form_status": "無資料",
              "request_amount": "0",
              "remit_amount_final": "0"
            }
          ]
        }
      ],
      remain_balance: null,
      cnt_count: 0,
      sum_count: 0,
    }
  },
  props: [

  ],
  methods: {
    getYYYYMMDD: function(target_date) {

      let format_date = target_date.getFullYear() + '-' + 
      ("0" + (target_date.getMonth() + 1)).slice(-2) + '-' + 
      ("0" + target_date.getDate()).slice(-2)

      return format_date

    },
    chose_target_payment_date(item){
       this.tmp_operation_item = item;
       this.modalShowDatePicker = true;
    },
    confirm_target_payment_date(){
      console.log(this.tmp_operation_item)
      console.log(this.target_payment_date)
      console.log(typeof(this.target_payment_date))
      console.log(this.getYYYYMMDD(new Date(this.target_payment_date)))
      let format = this.getYYYYMMDD(new Date(this.target_payment_date))
      let options = { hour12: false };
      let time = new Date(this.target_payment_date).toLocaleString('en-US', options).split(', ')[1];
      this.confirm_operation(this.tmp_operation_item, format + ' ' + time)
    },
    cancel_target_payment_date() {
      this.modalShowDatePicker = false
      this.this.target_payment_date = new Date()
      this.tmp_operation_item = null
    },
    popupFilterList() {
      //formListFiltered由formList篩選完刷新
      let that = this
      this.formListFiltered = []
      console.log('進！')
      
      this.formList.forEach(element => {
        if (
          (this.popup_filter_no == '' || element.PF.includes(this.popup_filter_no) || element.invoice_no.includes(this.popup_filter_no)) &&
          (this.popup_filter_name == '' || element.merchant_name.includes(this.popup_filter_name))
        ) {
          this.formListFiltered.push(JSON.parse(JSON.stringify(element)))
        }
      });

      if (this.popup_filter_start_at !== null && this.popup_filter_end_at !== null) {
        this.formListFiltered = this.formListFiltered.filter(function(form){
          let download_time = new Date(form.download_confirm_time)
          download_time = download_time.getTime()
          return download_time >= new Date(that.popup_filter_start_at).getTime() && download_time <= new Date(that.popup_filter_end_at)
        })
      }

    },
    async download_detail_xls() {
      let Param = {
        apiTarget:'ntsa',
        module:'payment_operation',
        method:'downloadPaymentOperationDetailXls',
        payment_operation_id:this.focus_operation_id
      }
      let vm = this
      let url = await apiDownloadPaymentOperationDetailXls(Param).then(function(resp){
        let data = resp.data
        return data.data.url
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
          vm.loading = false
          return
        }
      })

      if (!url) {
        return
      }

      let download_url = ''
      download_url = url.replace('/api/ticket', '')

      apiDownloadFile(download_url).then(function(resp){
          const url = window.URL.createObjectURL(new Blob([resp.data], {type:'application/vnd.ms-excel'}));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', download_url.split('&name=')[1]);
          document.body.appendChild(link);
          link.click();
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
      //     vm.loading = false
      //     return
      //   }
      //   saveAs(vm.getBlobFromBase64(data.data.xlsx),data.data.file_name)
      // },this)
    },
    showOperationDetail(operation) {
      let Param = {
        'apiTarget':'ntsa',
        'module':'payment_operation',
        'method':'getPaymentOperationDetailSummary',
        'payment_operation_id':operation.id,
      }
      let vm = this
      apiGetPaymentOperationDetailSummary(Param).then(function(resp){
        let data = resp.data
          // eslint-disable-next-line
          vm.operation_detail = data.data
          vm.focus_operation_id = operation.id
          vm.modalShowDetail = true
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.operation_detail = vm.operation_detail_default
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.operation_detail = vm.operation_detail_default
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     vm.operation_detail = data.data
      //     vm.focus_operation_id = operation.id
      //     vm.modalShowDetail = true
      // },this)
    },
    confirmCancel(operation) {
      this.$bus.fnShowConfirm("確認要取消嗎?", () => {
        let Param = {
          'apiTarget':'ntsa',
          'module':'payment_operation',
          'method':'cancelPaymentOperation',
          'payment_operation_id':operation.id,
          'remark':'後台取消放款作業',
        }
        let vm = this
        apiCancelPaymentOperation(Param).then(function(resp){
          let data = resp.data
          vm.searchOperations()
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo('已完成取消')
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //       return
        //   }
        //   vm.searchOperations()
        //   vm.$bus.fnClosePopup()
        //   vm.$bus.fnShowInfo('已完成取消')
        // }, this)
      })
    },
    manaulCreateOperationConfirm() {      
      //用this.formList裡有selected的表單建立放款作業
      let form_ids = ''
      let vm = this
      //會hoisting所以不能refuce跑完再let Param裡面使用form_ids喔
      let Param = {
        'apiTarget':'ntsa',
        'module':'payment_operation',
        'method':'createPaymentOperationManual',
        'total_amount':this.create_total,
        'remark':''
      }
      //this.formList.reduce
      form_ids = this.formListFiltered.reduce(function (prev, val) {
        if (val.selected) {
          prev += (prev!==''?',':'') + val.payment_request_form_id
        }
        return prev;
      }, form_ids);
      Param.operation_form_ids = form_ids.split(',')
      apiCreatePaymentOperationManual(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        vm.$bus.fnShowInfo('建立成功,單號為:'+data.data.remit_file_id)
        setTimeout(() => {
          vm.modalManualCreateShow = false
          vm.searchOperations()
        }, 2000);
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // vm.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //   }
      //   // eslint-disable-next-line
      //   vm.$bus.fnShowInfo('建立成功,單號為:'+data.data.remit_file_id)
      //   setTimeout(() => {
      //     vm.modalManualCreateShow = false
      //     vm.searchOperations()
      //   }, 2000);
      // },vm)
    },
    selectAll() {
      this.create_total = "計算中..."
      this.create_total = 0
      this.formListFiltered.forEach(element => {
          element.selected = true
          this.create_total += element.request_amount
        }
      )
      this.$forceUpdate()
    },
    unSelectAll() {
      this.formListFiltered.forEach(element => {
          element.selected = false
        }
      )
      this.$forceUpdate()
      this.create_total = 0
    },
    calCreateTotal() {
      this.create_total = '重新計算中...'
      let vm = this
      //為什麼要settimeout?因為點下去選取還沒更新完此選項的value前就用未改變前的值計算好了,結果自然是...錯的= =
      setTimeout(() => {
        this.create_total = 0
        this.formListFiltered.forEach(element => {
            if (element.selected) {
              vm.create_total += element.request_amount
            }
          }
        )        
      }, 200);
    },
    switchLock() {
      this.filterOptions[this.lockIconIndex].btnIcon = this.filterOptions[this.lockIconIndex].btnIcon==='lock'?'unlock':'lock'
      this.$refs.filterForm.refreshModelVar('showForceCancel')
    },
    handleScroll(evt) {
      // 不要scroll到底時一次瞬間觸發好幾次載入
      if (this.calScrollRatio(evt) > 0.95) {
        setTimeout(() => {
          this.$refs.scrollarea.$emit('scrolldownend')
        }, 500);
      }
    },
    optionValueChanged(upd) {
      if (['aborted','downloaded','confirmed'].includes(upd.key)) {
        setTimeout(() => {
          this.GoSearch()
        }, 200);
      }
    },
    GoSearch () {
      this.searchOperations()
    },
    showManualCreate() {
      //撈出所有downloaded的請款單,顯示popup上供勾選
      let Param = {
        'module':'merchant',
        'method':'getPaymentRequestFormList',
        'merchant_id':0,
        'status':'downloaded-needpay',
        'create_from':'',
        'create_to':'',
        'tab':''
      }
      let vm = this
      apiGetPaymentRequestFormList(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        vm.formList = data.data.payment_request_forms
        vm.formList.forEach(element => {
          element.remit_amount_final = parseInt(element.remit_amount_final)
          element.selected = false
          if (element.download_confirm_time !== null && element.download_confirm_time !== '' ){
            element.download_confirm_time = new Date(element.download_confirm_time)
            element.format_download_confirm_time = new Date(element.download_confirm_time).toLocaleString()
          }
        });
        vm.formListFiltered = JSON.parse(JSON.stringify(vm.formList))
        vm.create_total = 0
        vm.modalManualCreateShow = true
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     vm.formList = data.data.payment_request_forms
      //     vm.formList.forEach(element => {
      //       element.remit_amount_final = parseInt(element.remit_amount_final)
      //       element.selected = false
      //       if (element.download_confirm_time !== null && element.download_confirm_time !== '' ){
      //         element.download_confirm_time = new Date(element.download_confirm_time)
      //         element.format_download_confirm_time = new Date(element.download_confirm_time).toLocaleString()
      //       }
      //     });
      //     vm.formListFiltered = JSON.parse(JSON.stringify(vm.formList))
      //     vm.create_total = 0
      //     vm.modalManualCreateShow = true
      // },this)
    },
    searchOperations (append=false) {
      if (this.isLoading) {
        return
      }
      if (append === true) {
        if (!this.hasMore) {
          return
        }
        this.pageNumber ++
      }
      else {
        this.pageNumber = 1
        this.hasMore = true
        this.$refs.wrapper.scrollTop = 0
      }
      let vm = this
      let Param = {
        'apiTarget':'ntsa',
        'module':'payment_operation',
        'method':'getPaymentOperationList',
        'form_id':vm.filterData.form_id?vm.filterData.form_id:'',
        'aborted':vm.filterData.aborted,
        'downloaded':vm.filterData.downloaded,
        'confirmed':vm.filterData.confirmed,
        'created_from':vm.filterData.created_from?vm.filterData.created_from:'',
        'created_to':vm.filterData.created_to?vm.filterData.created_to:'',
        'confirmed_from':vm.filterData.confirmed_from?vm.filterData.confirmed_from:'',
        'confirmed_to':vm.filterData.confirmed_to?vm.filterData.confirmed_to:'',
        'page_number':this.pageNumber,
        'items_per_page':this.itemsPerPage,
      }

      if (Param.created_from) {
        Param.created_from = Param.created_from.replaceAll('/', '-')
      }

      if (Param.created_to) {
        Param.created_to = Param.created_to.replaceAll('/', '-')
      }

      if (Param.confirmed_from) {
        Param.confirmed_from = Param.confirmed_from.replaceAll('/', '-')
      }

      if (Param.confirmed_to) {
        Param.confirmed_to = Param.confirmed_to.replaceAll('/', '-')
      }

      this.isLoading = true
      apiGetPaymentOperationList(Param).then(function(resp){
        let data = resp.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
        
        // eslint-disable-next-line
        // append (排序有助於之後找出起訖日期的最早時間,但動態改options.scrollTime沒用,就先不做)
        if (vm.pageNumber === 1) {
          vm.PaymentOperationList = data.data
        }
        else {
          vm.PaymentOperationList = vm.PaymentOperationList.concat(data.data)
        }
        if (data.data.length === vm.items_per_page ) {
          vm.hasMore = false
        }
        setTimeout(() => {
          vm.isLoading = false
        }, 500);
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      this.isLoading = false
      // vm.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //   }
      //   // eslint-disable-next-line
      //   // append (排序有助於之後找出起訖日期的最早時間,但動態改options.scrollTime沒用,就先不做)
      //   if (vm.pageNumber === 1) {
      //     vm.PaymentOperationList = data.data
      //   }
      //   else {
      //     vm.PaymentOperationList = vm.PaymentOperationList.concat(data.data)
      //   }
      //   if (data.data.length === vm.items_per_page ) {
      //     vm.hasMore = false
      //   }
      //   setTimeout(() => {
      //     vm.isLoading = false
      //   }, 500);
      // },vm)
    },
    downloadFile(operation) {
      if (operation.downloaded == 1) {
        this.$bus.fnShowConfirm(('之前下載過是否再次下載(請自行注意不要重複匯款處理喔)?'),() => {
          saveAs(this.getBlobFromBase64(operation.download_binary),operation.remit_file_name)  
          this.$bus.fnClosePopup()
          return
        }, () => {
          this.$bus.fnClosePopup()
          return 
        })
        //不用再呼叫api更新為已下載
        return
      }
      let vm = this
      //呼叫api去更新為已下載(更新成功再另存@_@)
      let Param = {
        'apiTarget':'ntsa',
        'module':'payment_operation',
        'method':'setPaymentOperationDownloaded',
        'payment_operation_id':operation.id
      }

      apiSetPaymentOperationDownloaded(Param).then(function(resp){

        saveAs(vm.getBlobFromBase64(operation.download_binary),operation.remit_file_name)
        setTimeout(() => {
          //刷新一下不然還是顯示未下載
          vm.searchOperations()
        }, 500);

      }).catch(function(error){

        if (!error.response){
          console.log(error)
          return
        }

        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }

      })
      // vm.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //   }
      //   saveAs(vm.getBlobFromBase64(operation.download_binary),operation.remit_file_name)
      //   setTimeout(() => {
      //     //刷新一下不然還是顯示未下載
      //     vm.searchOperations()
      //   }, 500);
      // },vm)
    },
    downloadXls(operation) {
      if (operation.downloaded == 1) {
        this.$bus.fnShowConfirm(('之前下載過是否再次下載(請自行注意不要重複匯款處理喔)?'),() => {
          saveAs(this.getBlobFromBase64(operation.remit_xls_base64),operation.remit_file_id+'.xls')
          this.$bus.fnClosePopup()
          return
        }, () => {
          this.$bus.fnClosePopup()
          return 
        })
        //不用再呼叫api更新為已下載
        return
      }
      let vm = this
      //呼叫api去更新為已下載(更新成功再另存@_@)
      let Param = {
        'apiTarget':'ntsa',
        'module':'payment_operation',
        'method':'setPaymentOperationDownloaded',
        'payment_operation_id':operation.id
      }
      apiSetPaymentOperationDownloaded(Param).then(function(resp){
        let data = resp.data
        saveAs(vm.getBlobFromBase64(operation.remit_xls_base64),operation.remit_file_id+'.xls')
        setTimeout(() => {
          //刷新一下不然還是顯示未下載
          vm.searchOperations()
        }, 500);
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // vm.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //   }
      //   saveAs(vm.getBlobFromBase64(operation.remit_xls_base64),operation.remit_file_id+'.xls')
      //   setTimeout(() => {
      //     //刷新一下不然還是顯示未下載
      //     vm.searchOperations()
      //   }, 500);
      // },vm)
    },
    confirm_operation(operation, target_payment_date) {
      let vm = this
      //呼叫api去更新為已下載(更新成功再另存@_@)
      let Param = {
        'apiTarget':'ntsa',
        'module':'payment_operation',
        'method':'setPaymentOperationConfirmed',
        'payment_operation_id':operation.id,
        "target_payment_date": target_payment_date,
      }
      apiSetPaymentOperationConfirmed(Param).then(function(resp){
        vm.$bus.fnShowInfo("已更新成功")
        vm.cancel_target_payment_date()
        setTimeout(() => {
          //刷新一下不然還是顯示未下載
          vm.searchOperations()
        }, 500);
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      console.log(Param)
      // vm.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //   }
      //   vm.$bus.fnShowInfo("已更新成功")
      //   vm.cancel_target_payment_date()
      //   setTimeout(() => {
      //     //刷新一下不然還是顯示未下載
      //     vm.searchOperations()
      //   }, 500);
      // },vm)
    },
    getRemainBlance: function(){
      // 取得尚未信託金額
      let vm  = this
      apiGetTicketRemainBalance().then(function(resp){
        console.log(resp)
        vm.remain_balance = resp.data.data
        vm.remain_balance.detail.forEach(function(detail){
          vm.cnt_count += detail.cnt
          vm.sum_count += detail.sum
        })
      }).catch(function(error){
        console.log(error)
      })
    },
    parseType: function(type){
      switch (type){
        case 'electronic':
          return '電子票'
        case 'paper':
          return '紙本票'
        default:
          return type
      }
    },
    parseThousand: function(num){
        var str = num.toString();
        var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
        return str.replace(reg,"$1,");
    }
  },
  computed: {
    
  },
  created: function () {
    if (!this.$bus.session) {
      // 要重登入
      this.$bus.session = undefined
    }
    // 設定鎖頭按鈕的索引
    for (let i=0;i<this.filterOptions.length;i++) {
      if (this.filterOptions[i].akey === 'showForceCancel') {
        this.lockIconIndex = i
        break
      }
    }
  },
  mounted () {
    // 先關閉載入資料,否則四個切換控件初始化就會瞬間呼叫四次同樣api
    this.isLoading = true
    this.$refs.filterForm.initDefault()
    // 取未信託餘額
    this.getRemainBlance()
    setTimeout(() => {
      this.isLoading = false
      this.searchOperations()
    }, 1000);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper2 {
  height: 58vh;
  overflow-y: scroll;
  border-style: inset;
}
.form_selection_table {
  height: 400px;
  overflow-y: scroll;
}
.remain_table {
  border-collapse: collapse;
  margin-bottom: 5px;
  width: 400px;
  border-radius: 3px;
}
.remain_table > thead, .remain_table > tbody{
  border: 2px #CCC solid;
}
.remain_table > thead > th {
  border-right: 2px #CCC solid;
}
.remain_table > tbody > tr > td{
  border-right: 2px #CCC solid;
  border-bottom: 2px #CCC solid;
}
.cnt,.sum {
  text-align: right;
}
.type{
  text-align: left;
}
</style>
